import { Component } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, Validators } from '@angular/forms';
import { GroupedFileMetadata } from '@models/mood/metadata';
import { LAYER_TYPE } from 'src/app/core/layers/base-layer.class';
import { RasterLayerFormComponent } from '../raster-layer-form/raster-layer-form.component';


export interface GroupedFileFormConfiguration {
  filename: FormControl<string | null>;
  description: FormControl<string | null>;
}

@Component({
  selector: 'mood-admin-grouped-file-form',
  templateUrl: './grouped-file-form.component.html',
  styleUrls: [
    'grouped-file-form.component.scss'
  ]
})
export class GroupedFileFormComponent {
  constructor(private _controlContainer: ControlContainer) { }

  get formGroupContainer() {
    return this._controlContainer.control as FormGroup;
  }

  public static createMetadataFormGroup(existingConfig?: GroupedFileMetadata) {
    let formGroup = (RasterLayerFormComponent.createMetadataFormGroup(existingConfig) as unknown) as FormGroup<GroupedFileFormConfiguration>;

    formGroup.addControl('filename', new FormControl<string | null>({ value: existingConfig?.filename || null, disabled: true }, [Validators.required]));
    formGroup.addControl('description', new FormControl<string  | null>(existingConfig?.description || null, [Validators.required]));

    return formGroup;
  }
}
